import { h } from 'preact';
import { Router, Route } from 'preact-router';
import { Suspense } from 'preact/compat';
import { context, store } from './stores';
import { Faq, Sidebar, ContactUs, ViewerRatings, Rules, VideoHelp, NotFound, MailFaq, AdultRatings, WizardReg, MailOverview, MailControl, Terms, Events, PrivacyPolicy, ChathostResources, Logon, AgeVerification, MyAgreements, AgreementDownload, PromotionAgreement, ConsentAgreement, Consent, StudioResources, LuckyChats, Anniversary, ValentinesMatch, StudioLogon, StudioAccountVerification, StudioPrivacyPolicy, StudioTerms, Account, StudioAccount, RevenueDetails, ListPayments, StudioRevenueDetails, StudioListPayments } from './routes';
import { ROUTE, ROUTE_STUDIO, ROUTE_SUFFIX } from './common/constants';
import { RouteComponentProps } from './common/types';
import UserType from './common/usertype';
import { isRouteGuarded, isStudioRoute, redirectURL } from './common/utils';
import Head from './components/layout/head';
import Spinner from './components/loader';
import Layout from './components/layout/';
import RefreshToken from './components/session/refresh-token';
import WSStatus from './components/session/status';
import './less/app.less';

const App = () => {
    return (
        <context.Provider value={store}>
            <Head />
            <Router>
                <Route
                    path={ROUTE.SIDEBAR}
                    component={() => {
                        return (
                            <Suspense fallback={<Spinner />}>
                                <Sidebar sidebarType={UserType.CHATHOST} />
                            </Suspense>
                        );
                    }}
                />
                <Route
                    path={ROUTE_STUDIO.SIDEBAR}
                    component={() => {
                        return (
                            <Suspense fallback={<Spinner />}>
                                <Sidebar sidebarType={UserType.STUDIO} />
                            </Suspense>
                        );
                    }}
                />
                <Route
                    default
                    component={(props: RouteComponentProps) => {
                        if (!store.user.isLoggedIn.value && isRouteGuarded(props.url)) {
                            const gotoURL = props.url ? `?gotoURL=${encodeURIComponent(props.url)}` : '';
                            const redirect = isStudioRoute(props.url) ? ROUTE_STUDIO.LOGON : ROUTE.LOGON;
                            redirectURL(`${redirect}${gotoURL}`);
                            return null;
                        }

                        return (
                            <Layout>
                                <Suspense fallback={<Spinner />}>
                                    <Router>
                                        <Route path={ROUTE.HOMEPAGE} component={ChathostResources} />
                                        <Route path={ROUTE_STUDIO.HOMEPAGE} component={StudioResources} />
                                        <Route path={ROUTE.CHATHOST_RESOURCES} component={ChathostResources} />
                                        <Route path={`:section/${ROUTE_SUFFIX.FAQ}`} component={Faq} />
                                        <Route path={`:section/${ROUTE_SUFFIX.CONTACT_US}`} component={ContactUs} />
                                        <Route path={ROUTE.VIEWER_RATINGS} component={ViewerRatings} />
                                        <Route path={`:section/${ROUTE_SUFFIX.RULES}`} component={Rules} />
                                        <Route path={`:section/${ROUTE_SUFFIX.VIDEO_HELP}`} component={VideoHelp} />
                                        <Route path={`:section/${ROUTE_SUFFIX.EVENTS}`} component={Events} />
                                        <Route path={`:section/${ROUTE_SUFFIX.ADULT_RATINGS}`} component={AdultRatings} />
                                        <Route path={ROUTE.ACCOUNT} component={Account} />
                                        <Route path={ROUTE.WIZARD_REG} component={WizardReg} />
                                        <Route path={ROUTE.AGE_VERIFICATION} component={AgeVerification} />
                                        <Route path={ROUTE.MAIL_OVERVIEW} component={MailOverview} />
                                        <Route path={ROUTE.MAIL_CONTROL} component={MailControl} />
                                        <Route path={ROUTE.MAIL_FAQ} component={MailFaq} />
                                        <Route path={ROUTE.TERMS_AND_CONDITIONS} component={Terms} />
                                        <Route path={ROUTE.PRIVACY_POLICY} component={PrivacyPolicy} />
                                        <Route path={ROUTE.LOGON} component={Logon} />
                                        <Route path={ROUTE_STUDIO.LOGON} component={StudioLogon} />
                                        <Route path={ROUTE_STUDIO.ACCOUNT_VERIFICATION} component={StudioAccountVerification} />
                                        <Route path={ROUTE_STUDIO.PRIVACY_POLICY} component={StudioPrivacyPolicy} />
                                        <Route path={ROUTE_STUDIO.TERMS_AND_CONDITIONS} component={StudioTerms} />
                                        <Route path={ROUTE_STUDIO.REVENUE_DETAILS} component={StudioRevenueDetails} />
                                        <Route path={ROUTE_STUDIO.PAYMENTS_LIST} component={StudioListPayments} />
                                        <Route path={ROUTE_STUDIO.ACCOUNT} component={StudioAccount} />
                                        <Route path={ROUTE.MY_AGREEMENTS} component={MyAgreements} />
                                        <Route path={ROUTE.PROMOTION_AGREEMENT} component={PromotionAgreement} />
                                        <Route path={ROUTE.AGREEMENT_DOWNLOAD} component={AgreementDownload} />
                                        <Route path={ROUTE.CONSENT_AGREEMENT} component={ConsentAgreement} />
                                        <Route path={ROUTE.CONSENT} component={Consent} />
                                        <Route path={ROUTE.LUCKY_CHATS} component={LuckyChats} />
                                        <Route path={ROUTE.ANNIVERSARY} component={Anniversary} />
                                        <Route path={ROUTE.VALENTINES} component={ValentinesMatch} />
                                        <Route path={ROUTE.REVENUE_DETAILS} component={RevenueDetails} />
                                        <Route path={ROUTE.PAYMENTS_LIST} component={ListPayments} />
                                        <Route path={ROUTE.NOT_FOUND} component={NotFound} default />
                                    </Router>
                                </Suspense>
                            </Layout>
                        );
                    }}
                />
            </Router>
            <RefreshToken />
            <WSStatus />
        </context.Provider>
    );
};

export default App;
